export const LESCAPES_SIGNUP_DOMAIN = 'Luxury Escapes'

export const APPLE_PRIVATE_DOMAIN = 'privaterelay.appleid.com'

export const ADMIN_ROLE = 'admin-user'
export const MARKETING_ADMIN_ROLE = 'marketing-admin'
export const EMPLOYEE_ROLE = 'employee'
